export interface IState {
  customerEstimateList: any;
  customerEstimateCount: number;
  CustomerEstimateDetails: any;
  customer_main_estimate_data: any;
  CustomerEstimateForChangeOrder: any;
  CustomerestimateChangeOrderList:any
}

type Action = any;

export const customerEstimateReducer = (
  state: IState = {
    customerEstimateList: [],
    CustomerEstimateDetails: null,
    customerEstimateCount: 0,
    customer_main_estimate_data: null,
    CustomerEstimateForChangeOrder: null,
    CustomerestimateChangeOrderList:[]
  },
  action: Action
): any => {
  switch (action.type) {
    case "GET_CUSTOMER_ESTIMATE":
      return {
        ...state,
        customerEstimateList:
          action?.payload?.page == 1
            ? action?.payload?.data
            : [...state?.customerEstimateList, ...action?.payload?.data],
        customerEstimateCount: action?.payload?.count,
      };
    case "GET_CUSTOMER_ESTIMATE_DETAILS":
      return {
        ...state,
        CustomerEstimateDetails: action?.payload,
      };
    case "GET_CUSTOMER_MAIN_ESTIMATE_DETAILS":
      return {
        ...state,
        customer_main_estimate_data: action?.payload,
      };

    case "CUSTOMER_ESTIMATE_FOR_CHANGE_ORDER":
      return {
        ...state,
        CustomerEstimateForChangeOrder: action?.payload,
      };
    case "CUSTOMER_ESTIMATE_CHANGE_ORDERS_LIST":
      return {
        ...state,
        CustomerestimateChangeOrderList: action?.payload,
      };

    default:
      return state;
  }
};
